const buildHeaders = (cloudId?: string, product: string = 'platform') => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');

	if (cloudId && product) {
		const atlAttributionHeader = {
			tenantId: cloudId,
			product,
		};
		headers.append('atl-attribution', JSON.stringify(atlAttributionHeader));
	}

	return headers;
};

interface Query {
	query: string;
	variables: Record<string, string> | Record<string, string[]>;
}

export interface GraphQLError {
	code?: number;
	reason: string;
}

/**
 * @param {string} serviceUrl - GraphQL service endpoint
 * @param {Query} query - GraphQL query
 * @param {string} cloudId - Cloud ID (tenantId)
 * @param {string} product - Product key
 */
export function graphqlQuery<D>(
	serviceUrl: string,
	query: Query,
	cloudId?: string,
	product?: string,
): Promise<D> {
	const headers = buildHeaders(cloudId, product);

	return fetch(
		new Request(`${serviceUrl}`, {
			method: 'POST',
			credentials: 'include',
			mode: 'cors',
			headers,
			body: JSON.stringify(query),
		}),
	)
		.then((response) => {
			if (!response.ok) {
				return Promise.reject({
					code: response.status,
					reason: response.statusText,
				});
			}

			return response;
		})
		.then((response) => response.json())
		.then((json) => {
			if (json.errors) {
				return Promise.reject({
					reason: json.errors[0]?.category || 'default',
				});
			}

			return json.data;
		});
}
